import { Skeleton } from "@mui/material";
import { Animation, Variant } from "./const";
import { PropTypes } from 'prop-types';

const FmlxSkeleton = ({
    variant,
    animation,
    height, 
    width,
    children,
    component,
    className, 
  }) => {
    return (
      <Skeleton
        variant={variant}
        animation={animation}
        height={height}
        width={width}
        component={component}
        className={className}
      >
        {children}
      </Skeleton>
    );
};

FmlxSkeleton.Variant= Variant;
FmlxSkeleton.Animation= Animation

FmlxSkeleton.propTypes = {
    variant: PropTypes.oneOf(Object.values(Variant)),
    animation: PropTypes.oneOf(Object.values(Animation)),
    height: PropTypes.number,
    width: PropTypes.number,
    children: PropTypes.node,
    component: PropTypes.elementType,
    className: PropTypes.string,
};

FmlxSkeleton.defaultProps = {
    variant: Variant.DEFAULT,
    animation: Animation.STATIC,
    height: 40,
    width: 210,
    children: null,
    component: 'div',
    className: '',
};

export default FmlxSkeleton;